module.exports = __webpack_public_path__ + "media/images/classpoints/classpoints-hero_cyclebar-258dfa77a3dbfeace48cbf71d0794b0b.png";